<template>
  <section>
    <LoadingOliver v-if="loadingapi" />

    <div v-else class="col-12">
      <div class="card p-4">
      <table class="table table-striped">
        <thead>
          <th>Time</th>
          <th>{{ $t("lang.label.order")}}</th>
          <th>{{ $t("lang.label.subject")}}</th>
          <th>{{ $t("lang.label.message")}}</th>
        </thead>
        <template v-for="item in targetMissinDataItems">
          <tr :key="item.id">
            <td>
              <span
                v-if="item.task_open_hours !== null"
                class="badge"
                :class="taskOpenHoursClass(item.task_open_hours)"
              >
                {{ item.task_open_hours }} h
              </span>
            </td>
            <td>
              <router-link target="_blank" class="text-primary"
                :to="'/orders/' + item.id"
                @mousedown.native="mousedown('/orders/' + item.id)"
              >
                {{ item.name }}
              </router-link>
              <div class="small">
                  Total queue {{ item.total }}
              </div>
            </td>
            <td><span v-html="item.subject"></span></td>
            <td><span v-html="item.message"></span></td>
          </tr>
        </template>
      </table>
      </div>
    </div>
  </section>
</template>

<script>
import { targetsService } from "@/_services";
import LoadingOliver from "@/components/LoadingOliver.vue";

export default {
  name: 'TargetMissingData',

  data() {
    return {
      targetMissinDataItems: [],
      loadingapi: false,
    };
  },

  mounted() {
    this.getTargetMissingData();
  },


  components: {
    LoadingOliver,
  },

  methods: {
    getTargetMissingData() {
      this.loadingapi = true;
      targetsService.getTargetMissingData(13).then((result) => {
        this.targetMissinDataItems = result;

        this.loadingapi = false;
      });
    },
    taskOpenHoursClass(task_open_hours) {
      if (task_open_hours < 24) {
        return "badge-warning";
      }else if (task_open_hours < 12) {
        return "badge-warning";
      }
      return "badge-danger";
    },
  },

};
</script>
